import { Link } from "react-router-dom";

export default function HomeLink() {
    return (
        <div style={{fontSize: '16px', marginTop: '20px'}}>&lt; <Link to='/'>home</Link></div>
    )
}
